
// AreceberPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirAreceber from '../../components/ExibirAreceber.js';
import CadastrarAreceber from '../../components/CadastrarAreceber.js';
import EditarAreceber from '../../components/EditarAreceber.js';
import ListarAreceber from '../../components/ListarAreceber.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig'; 
import '../../App.css';

function AreceberPage() {
  const { theme } = useTheme();
  // eslint-disable-next-line no-unused-vars
  const [areceber, setAreceber] = useState([]);
  const [selectedAreceber, setSelectedAreceber] = useState("");
  const [showCadastroAreceber, setShowCadastroAreceber] = useState(false);
  const [showEditaAreceber, setShowEditaAreceber] = useState(false);
  const [showExibeAreceber, setShowExibeAreceber] = useState(false);
  const [showListaAreceber, setShowListaAreceber] = useState(false); // Estado para controlar a exibição do componente ListarAreceber
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codvenda: '', nomecli: '', cnpjcli: '' });
  const navigate = useNavigate(); // Definindo o useNavigate
  
// Função para Carregar as Contas a Receber
const loadAreceber = async (pageNumber = 1) => {
  console.log('Carregando Areceber...');
  try {
    // Primeiro, carregue a quantidade total de Contas a Receber
    const countResponse = await api.get(`/areceber/listarareceber`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
    
    const totalAreceber = countResponse.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalAreceber / pageSize);
    
    // Solicite a última página de Conta a Receber
    const lastPage = totalPages > 0 ? totalPages - 1 : 0;
    const response = await api.get(`/areceber/listarareceber/paginados?page=${lastPage}&size=${pageSize}`);
  // {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
    
    setAreceber(response.data.content);
    
    // Se houver Contas, selecione a última Conta a Receber
    if (response.data.content.length > 0) {
      const lastAreceber = response.data.content[response.data.content.length - 1];
      setSelectedAreceber(lastAreceber);
      setShowExibeAreceber(true);
    }
    
    setTotalPages(totalPages);
  } catch (error) {
    console.error('Erro ao carregar Contas a Receber:', error);
  }
  };
  
  
// Função para exibir Conta a Receber selecionada
const handleIdClick = async (areceberId) => {
  try {
    handleSairListarClick(); // Fechar componente de listagem

    // Buscar a conta a receber pela ID única da parcela
    const response = await api.get(`/areceber/buscarareceber/${areceberId}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
    
    if (response.data) {
      const areceber = response.data; // Você está buscando pelo ID, não precisa de array
      setSelectedAreceber(areceber);
      setShowExibeAreceber(true);
    } else {
      window.alert('Conta a Receber não Encontrada.');
    }
  } catch (error) {
    console.error('Erro ao buscar Conta a Receber:', error);
    window.alert('Erro ao buscar Conta a Receber. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar a primeira Conta a Receber
const fetchPrimeiroAreceber = async () => {
  try {
    const response = await api.get('/areceber/primeiro');
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
    
    if (response.data && response.data.codvenda) {
      console.log('Primeira Conta a Receber Encontrada:', response.data);
      setSelectedAreceber(response.data);
      setShowExibeAreceber(true);
      } else {
        console.log('Nenhuma Conta a Receber Cadastrada.');
        setSelectedAreceber(response.data);
        setShowExibeAreceber(true);
        window.alert('Nenhuma Conta a Receber Cadastrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar a Primeira Conta a Receber:', error);
      setSelectedAreceber("");
      setShowExibeAreceber(true);
      window.alert('Nenhuma Conta a Receber Cadastrada.');
    }
  };
  
// Função para buscar a Conta a Receber Anteriorr
const fetchAreceberAnterior = async () => {
  if (selectedAreceber && selectedAreceber.id) {
    console.log('Buscando venda anterior para o ID:', selectedAreceber.id);
    try {
      const response = await api.get(`/areceber/anterior/${selectedAreceber.id}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
      
      if (response.data) {
        setSelectedAreceber(response.data);
        setShowExibeAreceber(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Trata a resposta 404 como o primeiro registro encontrado
        window.alert('Primeiro Registro Encontrado.');
      } else {
        console.error('Erro ao buscar o Conta anterior:', error);
        window.alert('Erro ao buscar o registro anterior. Tente novamente.');
      }
    }
  } else {
    console.error('Nenhuma Conta selecionada ou Conta sem ID');
    window.alert('Nenhuma Conta selecionada para buscar o registro anterior.');
  }
};
  
// Função para buscar a venda posterior
const fetchAreceberPosterior = async () => {
  if (selectedAreceber && selectedAreceber.id) {
    console.log('Buscando venda posterior para o ID:', selectedAreceber.id);
    try {
      const response = await api.get(`/areceber/proximo/${selectedAreceber.id}`);
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})

      if (response.data) {
        setSelectedAreceber(response.data);
        setShowExibeAreceber(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Trata a resposta 404 como o último registro encontrado
        window.alert('Último Registro Encontrado.');
      } else {
        console.error('Erro ao buscar o Conta posterior:', error);
        window.alert('Erro ao buscar o registro posterior. Tente novamente.');
      }
    }
  } else {
    console.error('Nenhuma Conta selecionada ou Conta sem ID');
    window.alert('Nenhuma Conta selecionada para buscar o registro posterior.');
  }
};
  

// Função para buscar a última Conta a Receber
const fetchUltimoAreceber = async () => {
  try {
    const response = await api.get('/areceber/ultimo');
  //, {
  //headers: {
  //Authorization: `Bearer ${localStorage.getItem('token')}`
  //}
  //})
    
    if (response.data) {
      //console.log('Última Conta encontrada:', response.data);
      setSelectedAreceber(response.data);
      setShowExibeAreceber(true);
    }
  } catch (error) {
    console.error('Erro ao buscar a última Conta:', error);
  }
};

  
  // Efeito para carregar a última Conta quando o componente for montado
    useEffect(() => {
    fetchUltimoAreceber();
  }, [currentPage]);


  // Função para Buscar Areceber por Código da Venda.
  const fetchAreceberPorCodvenda = async (codvenda) => {
    console.log('Buscando venda por Código da Venda:', codvenda);
    try {
      const response = await api.get(`/areceber/${codvenda}/areceber/primeira`, {
      headers: { 'Content-Type': 'application/json' }
      //, Authorization: `Bearer ${localStorage.getItem('token')}`
      });

    if (response.data) {
        console.log('Conta a Receber encontrada por Código da Venda:', codvenda);
      setSelectedAreceber(response.data);  // Acessa diretamente o objeto retornado
      console.log('Selected Areceber atualizado:', response.data);
      setShowExibeAreceber(true);
      } else {
        console.warn('Conta a Receber não encontrada por Código da Venda: ', codvenda);
        window.alert('Conta a Receber não encontrada por Código da Venda: ', codvenda);
        fetchUltimoAreceber();
      }
    } catch (error) {
      console.error('Erro ao buscar Conta a Receber por Código da Venda: ', error);
      window.alert('Conta a Receber Não Encontrada por Código da Venda: ', codvenda);
      fetchUltimoAreceber();
    }
  };


  // Função para Buscar Conta a Areceber por Nome do Cliente
  //const fetchAreceberPorNomecli = async (nomecli) => {
  //  console.log('Buscando Conta a Receber mais recente por Nome do Cliente:', nomecli);
  //  try {
  //      const response = await Axios.get(`http://localhost:8080/venda/buscarareceber?nomecli=${nomecli}`);
  //      if (response.data) {
  //          console.log('Conta a Receber encontrada por Nome do Cliente:', nomecli);
  //          setSelectedAreceber(response.data);
  //          setShowExibeAreceber(true);
  //      } else {
  //          console.warn('Conta a Receber não encontrada por Nome do Cliente:', nomecli);
  //          window.alert('Conta a Receber não encontrada por Nome do Cliente:', nomecli);
  //          fetchUltimoAreceber();
  //      }
  //  } catch (error) {
  //      console.error('Erro ao buscar Conta a Receber por Nome do Cliente:', error);
  //      window.alert('Erro ao buscar Conta a Receber por Nome do Cliente');
  //      fetchUltimoAreceber();
  //  }
  //};

  // Função para buscar Conta a Receber mais recente por CNPJ do Cliente
  //const fetchAreceberPorCnpjcli = async (cnpjcli) => {
  //  console.log('Buscando Conta a Receber por CNPJ do Cliente:', cnpjcli);
  //  try {
  //      const response = await Axios.get(`http://localhost:8080/venda/buscarareceber?cnpjcli=${cnpjcli}`);
  //      if (response.data) {
  //          console.log('Conta a Receber encontrada por CNPJ do Cliente:', cnpjcli);
  //          setSelectedAreceber(response.data);
  //          setShowExibeAreceber(true);
  //      } else {
  //          console.warn('Conta a Receber não encontrada por CNPJ do Cliente:', cnpjcli);
  //          window.alert('Conta a Receber não encontrada por CNPJ do Cliente:', cnpjcli);
  //          fetchUltimoAreceber();
  //      }
  //  } catch (error) {
  //      console.error('Erro ao buscar Conta a Receber por CNPJ do Cliente:', error);
  //      window.alert('Erro ao buscar Conta a Receber por CNPJ do Cliente');
  //      fetchUltimoAreceber();
  //  }
  //};

  // Função para listar Contas a Receber cadastradas
  const handleListarClick = () => {
    setShowListaAreceber(true); // Ao clicar no botão Listar, mostrar o componente ListarAreceber
    setShowExibeAreceber(false); // Esconder o componente ExibirAreceber
  };

  // Função para sair do ListarAreceber
  const handleSairListarClick = () => {
    setShowListaAreceber(false); // Ao clicar no botão Sair do ListarAreceber, esconder o componente ListarAreceber
    setShowExibeAreceber(true); // Mostrar novamente o componente ExibirAreceber
  };

  // Função para cadastrar Nova Conta a Receber
  //const handleNovoClick = () => {
  //  setSelectedAreceber("");
  //  setShowCadastroAreceber(true);
  //  setShowEditaAreceber(false);
  //  setShowExibeAreceber(false);
  //};

  // Função para Salvar Cadastro Nova conta a Receber
  const handleSalvarNovaAreceber = (areceber) => {
    setAreceber([...areceber, areceber]);
    setSelectedAreceber(areceber);
    setShowCadastroAreceber(false);
    setShowExibeAreceber(false);
    setShowEditaAreceber(true);
    ///window.alert('Conta a Receber Salva com Sucesso');
  };


  // Função para cancelar o cadastro da venda
  const handleCancelarNovaAreceber = () => {
    setShowCadastroAreceber(false);
    fetchUltimoAreceber(); // Carrega a última Conta a Receber da lista
    setShowExibeAreceber(true);
  };



  // Função para editar Conta a Receber Selecionada
  //const handleEditClick = () => {
  //  setShowEditaAreceber(true);
  //  setShowCadastroAreceber(false);
  //  setShowExibeAreceber(false);
  //};


// Função para Salvar Conta a Receber Exibida
const handleSaveAreceber = async (areceberAtualizado) => {
  try {
    // Aqui você pode atualizar a lista de contas a receber sem duplicar
    setAreceber((prev) =>
      prev.map((item) => (item.id === areceberAtualizado.id ? areceberAtualizado : item))
    );

    // Opcionalmente, faça uma nova requisição para garantir que os dados estão corretos
    //const response = await Axios.get(`http://localhost:8080/venda/buscarareceber/${areceberAtualizado.id}`);
    //const updatedAreceber = response.data;

    // Atualize o estado com o registro atualizado
    //setSelectedAreceber(updatedAreceber);
    setShowExibeAreceber(true);
    setShowEditaAreceber(false);

    // Alerta opcional
    // window.alert('Conta a Receber Editada com Sucesso');
  } catch (error) {
    console.error('Erro ao atualizar registro:', error);
    alert('Erro ao recarregar o registro atualizado.');
  }
};

  // Função para Salvar Conta a Receber Editada
  const handleSalvaEditada = (areceber) => {
    setAreceber([...areceber, areceber]);
    setSelectedAreceber(areceber);
    setShowExibeAreceber(true);
    setShowEditaAreceber(false);
    //window.alert('Conta a Receber Editada com Sucesso');
  };



  // Função para cancelar a edição da Conta a Receber
  const handleCancelaEditada = () => {
    setShowCadastroAreceber(false);
    setShowEditaAreceber(false);
    setShowExibeAreceber(true);
  };

  // Função para fechar a página de exibição e ir para a página inicial
  const handleCancelaExibe = () => {
    setShowCadastroAreceber(false);
    setShowEditaAreceber(false);
    setShowExibeAreceber(false);
    setAreceber(""); // Reseta o estado da venda
    navigate('/home'); // Redireciona para a página inicial
  };


const handleDeleteClick = async () => {
  if (selectedAreceber) {
    const confirmation = window.confirm(`Tem certeza que deseja excluir a Conta ${selectedAreceber.id}?`);
    if (confirmation) {

      // Procede com a exclusão da Conta a Receber
      await api.delete(`/areceber/${selectedAreceber.id}`, {
      headers: { 'Content-Type': 'application/json' }
      //, Authorization: `Bearer ${localStorage.getItem('token')}`
      });

      window.alert(`Areceber: ${selectedAreceber.id} Excluída com Sucesso.`);

      // Carregar vendas novamente
      loadAreceber(currentPage);
      // Buscar e exibir a última Conta a Receber
      fetchUltimoAreceber();
      
    }
  } else {
    console.error('Nenhuma Conta a Receber selecionada para excluir');
  }
};

// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codvenda: '', nomecli: '', cnpjcli: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  // Se a tecla pressionada for Enter, executar a busca
  const handleSearchByCodigo = (e) => {
    if (e.key === 'Enter') {
      fetchAreceberPorCodvenda(searchQuery.codigo);
    }
  };

  //const handleSearchByNome = (e) => {
  //  if (e.key === 'Enter') {
  //    fetchAreceberPorNomecli(searchQuery.nome);
  //  }
  //};

  //const handleSearchByCNPJ = (e) => {
  //  if (e.key === 'Enter') {
  //    fetchAreceberPorCnpjcli(searchQuery.cnpj);
  //  }
  //};


  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedEmpresa={localStorage.getItem('selectedEmpresa')} />


{!showCadastroAreceber && selectedAreceber && !showEditaAreceber && showExibeAreceber && (
  <>
    <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiroAreceber}
      fetchAnterior={fetchAreceberAnterior}
      fetchProximo={fetchAreceberPosterior}
      fetchUltimo={fetchUltimoAreceber}
    />
    <BotoesDeAcao
      //handleNovoClick={handleNovoClick}
      //handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      //handleSearchByNome={handleSearchByNome}
      //handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
    />
    <ExibirAreceber
      areceber={selectedAreceber || {}}
      handleSaveAreceber={handleSaveAreceber}      
      handleCancelaExibe={handleCancelaExibe} 
      />
      </>
      )}
      
      {showListaAreceber && (
        <ListarAreceber
        onIdClick={handleIdClick} // Corrigindo para passar a função onIdClick
        handleSairListarClick={handleSairListarClick}
        />
      )}


      {showCadastroAreceber && (
        <CadastrarAreceber
          handleSaveClick={handleSalvarNovaAreceber}
          //handleCloseClick={handleFecharNovaAreceber}
          handleCancelaClick={handleCancelarNovaAreceber}
          areceber={selectedAreceber}
        />
      )}

      
      {showEditaAreceber && (
      <EditarAreceber
      areceber={selectedAreceber}
      handleEditClick={handleSalvaEditada}
      handleCancelaEdit={handleCancelaEditada}
      />
      )}
      
  </div>
  );
}

export default AreceberPage;